"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.stringify = void 0;
const tslib_1 = require("tslib");
const qs_1 = tslib_1.__importDefault(require("qs"));
const stringify = (params, options = {}) => {
    return qs_1.default.stringify(params, {
        addQueryPrefix: true,
        format: 'RFC1738',
        encodeValuesOnly: true,
        arrayFormat: 'brackets',
        sort: (a, b) => a.localeCompare(b),
        ...options
    });
};
exports.stringify = stringify;
const parse = (url, options = {}) => {
    return qs_1.default.parse(url, {
        ignoreQueryPrefix: true,
        ...options
    });
};
exports.parse = parse;
// export const stringifyFiltersParams = (data: unknown): string => {
// 	const params = data as Record<string, unknown>
// 	return stringify({
// 		...(params as Record<string, unknown>).filters as Record<string, unknown>,
// 		perPage: params.perPage,
// 		page: params.page
// 	})
// }
